import { observer } from 'mobx-react-lite';
import { User } from '../../../app/models/user';

interface Props {
    user: User
}

export default observer(function BillingAddressContent({ user }: Props) {
    return (
        <>
            {user?.billingAddress} {user?.billingAddress2}<br />
            {`${user?.billingCity ? `${user?.billingCity},` : ''}
            ${user?.billingState ? user?.billingState : ''} 
            ${user?.billingZipcode ? user?.billingZipcode : ''}`}<br />
        </>
    );
})